// Generated by purs version 0.15.15
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Accounts_Types_AccountId from "../Restaumatic.Accounts.Types.AccountId/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var eq = /* #__PURE__ */ Data_Eq.eq(Restaumatic_Accounts_Types_AccountId.eqAccountId);
var eq1 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Maybe.eqMaybe(Data_Eq.eqString));
var accountIdIsSymbol = {
    reflectSymbol: function () {
        return "accountId";
    }
};
var emailIsSymbol = {
    reflectSymbol: function () {
        return "email";
    }
};
var phoneIsSymbol = {
    reflectSymbol: function () {
        return "phone";
    }
};
var showMaybe = /* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showString);
var WithdrawMarketingConsentRequestIsSymbol = {
    reflectSymbol: function () {
        return "WithdrawMarketingConsentRequest";
    }
};
var decodeMaybe = /* #__PURE__ */ Unscramble.decodeMaybe(Unscramble.decodeString1);
var encodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons();
var encodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.stringEncode));
var decodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons();
var decodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.stringDecode));
var WithdrawMarketingConsentRequest = function (x) {
    return x;
};
var toFillFormTypeWithdrawMar = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var rPCSitesWithdrawMarketing = {};
var rPCMethodNameWithdrawMark = {
    rpcMethodName: function (v) {
        return "WithdrawMarketingConsentRequest";
    }
};
var newtypeWithdrawMarketingC = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldWithdrawMarketing = function (dictHasField) {
    return dictHasField;
};
var eqWithdrawMarketingConsen = {
    eq: function (x) {
        return function (y) {
            return eq(x.accountId)(y.accountId) && eq1(x.email)(y.email) && eq1(x.phone)(y.phone);
        };
    }
};
var genericWithdrawMarketingConsentRequest = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showWithdrawMarketingConsentRequest = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericWithdrawMarketingConsentRequest)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons(accountIdIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(emailIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(phoneIsSymbol)(showMaybe))(showMaybe))(Restaumatic_Accounts_Types_AccountId.showAccountId))))(WithdrawMarketingConsentRequestIsSymbol))
};
var unscrambleDecodeWithdrawMarketingConsentRequest = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericWithdrawMarketingConsentRequest)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons(accountIdIsSymbol)(Restaumatic_Accounts_Types_AccountId.decodeAccountId1)(/* #__PURE__ */ Unscramble.decodeRecordCons(emailIsSymbol)(decodeMaybe)(/* #__PURE__ */ Unscramble.decodeRecordCons(phoneIsSymbol)(decodeMaybe)(Unscramble.decodeRecordNil)))))))(Unscramble_Generic.defaultOptions)
};
var encodeWithdrawMarketingConsentRequest = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericWithdrawMarketingConsentRequest)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(WithdrawMarketingConsentRequestIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(Foreign_Generic_Class.encodeRecordNil)(phoneIsSymbol)(encodeWithOptionsOther))(emailIsSymbol)(encodeWithOptionsOther))(accountIdIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Accounts_Types_AccountId.encodeAccountId))))))
};
var decodeWithdrawMarketingConsentRequest = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericWithdrawMarketingConsentRequest)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(WithdrawMarketingConsentRequestIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(Foreign_Generic_Class.decodeRecordNil)(phoneIsSymbol)(decodeWithOptionsOther)())(emailIsSymbol)(decodeWithOptionsOther)())(accountIdIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Accounts_Types_AccountId.decodeAccountId))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
export {
    WithdrawMarketingConsentRequest,
    genericWithdrawMarketingConsentRequest,
    eqWithdrawMarketingConsen,
    showWithdrawMarketingConsentRequest,
    rPCMethodNameWithdrawMark,
    rPCSitesWithdrawMarketing,
    encodeWithdrawMarketingConsentRequest,
    decodeWithdrawMarketingConsentRequest,
    unscrambleDecodeWithdrawMarketingConsentRequest,
    toFillFormTypeWithdrawMar,
    hasFieldWithdrawMarketing,
    newtypeWithdrawMarketingC
};
